import React from 'react';
import './Modal.css';
import deleteIcon from "../../assets/images/deleteIcon_drawer.svg"
import Heading6Semibold from '../designSystem/Heading6Semibold';
import BodyMediumRegular from '../designSystem/BodyMediumRegular';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";

const DeleteVisitModal = ({ isVisible, onClose, onDeleteClick, isLoading }) => {
    const [loading, setLoading] = React.useState(false);

    const handleDelete = async () => {
        setLoading(true);
        try {
            await onDeleteClick();
        } catch (error) {
            console.error("Error deleting:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        isVisible && (
            <div className="modal-backdrop">
    <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <LoadingOverlay isVisible={loading} />
        <div className={loading ? 'blur' : ''}>
            <div className='content-container'>
                        <div className='icon-container'>
                            <img src={deleteIcon} />
                        </div>
                        <div className='text-container'>
                            <Heading6Semibold color='#1E293B' text='Delete Visit' />
                            <BodyMediumRegular
                                color='#384153'
                                text='Are you sure you want to delete all the selected visits? This action cannot be undone.'
                                textAlign='center'
                            />
                        </div>
                    </div>
                    <div className='button-contiainer'>
                        <button className='cancel-button'
                            onClick={onClose}
                        >
                            <BodyExtraSmallMedium color='#1E293B' text='Cancel' />
                        </button>
                                <button className='danger-button' onClick={handleDelete} disabled={loading}>
                                <BodyExtraSmallMedium color='#FFFFFF' text='Delete Visit' />
                        </button>

                    </div>
                </div>
            </div>
        </div>
        )
    );
};

export default DeleteVisitModal;
